import React, { createContext } from 'react';

const BenefitContext = createContext();

export default BenefitContext;